<template>
  <div class="aboutPrivacyThreeImg">
    <div class="aboutPrivacyThreeImg-box">
      <div 
        class="list-box" 
        v-for="(item, index) in list" 
        :key="index" >
        <img :src="item.img"  alt="">
        <div class="list-text">
          <h2>{{ item.title }}</h2>
          <p>{{ item.text }}</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      list: [
        // { img: require("https://mediakit.enabot.com/eboX/img/pc/pc_aboutPrivacy1.png"), title:"on-off toggle switch in the App", text: "to tilt down the camera" },
        // { img: require('https://mediakit.enabot.com/eboX/img/pc/pc_aboutPrivacy2.png'), title:"a structure shutter on EBO X", text: "to hide the camera" },
        // { img: require('https://mediakit.enabot.com/eboX/img/pc/pc_aboutPrivacy3.png'), title:"a privacy button on EBO X", text: "to turn off the camera and microphone." },
        { img: "https://mediakit.enabot.com/eboX/img/pc/pc_aboutPrivacy1.png", title:"on-off toggle switch in the App", text: "to tilt down the camera" },
        { img: 'https://mediakit.enabot.com/eboX/img/pc/pc_aboutPrivacy2.png', title:"a structure shutter on EBO X", text: "to hide the camera" },
        { img: 'https://mediakit.enabot.com/eboX/img/pc/pc_aboutPrivacy3.png', title:"a privacy button on EBO X", text: "to turn off the camera and microphone" },
      ],
    }
  }
}
</script>

<style lang="scss" scoped>
.aboutPrivacyThreeImg{
  .aboutPrivacyThreeImg-box {
    display: flex;
    max-width: 1200px;
    margin: 0 auto;
    justify-content: space-between;

    .list-box {
      width: 32.1%;
      height: auto;
      text-align: center;
      position: relative;
      .list-text {
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        width: 100%;
        top: 73%;
        font-size: 24px;
        // font-family: Source Han Sans CN;
        h2{
          font-size: 24px;
          font-weight: bold;
          color: #FFFFFF;
          line-height: 30px;
          width: 68%;
          margin: 0 auto 20px;
        }
        p{
          font-weight: 400;
          color: #FFFFFF;
          line-height: 26px;
          font-size: 16px;
          width: 80%;
          margin: 0 auto;
        }
      }
    }
  }
}
</style>